module.exports = __webpack_public_path__ + "img/ic_referafriend.3915341c.svg";